module.exports = __webpack_public_path__ + "img/section1-parallax8.bd79c3c6.png";